import api from '../api'

function secondTags(second_tags) {
  let secondTagStr = ''
  second_tags &&
    second_tags.forEach(tag => {
      secondTagStr += `<a target="_blank" href="${api.host}/qa/tag_${tag['id']}">
        <span>#${tag['name']}</span>
      </a>
    `
    })
  return secondTagStr
}

function questionReward(info, sshzv) {
  let question_reward = info['question_reward'],
    questionReward = ''
  if (!sshzv) {
    if (+info['quality_tag_id'] === 4) {
      questionReward = '<span class="crisis">危机</span>'
    } else if (question_reward && question_reward.question_id) {
      questionReward = '<span>悬赏</span>'
    }
  }
  return questionReward
}

function filterBr(content) {
  return (content + '').replace(/\s*/g, '').replace(/(<br>){2,}/g, '<br>')
}

module.exports = function(data, sshzv, mixed = false) {
  let tpl = ''
  let questionList = []
  let storyList = []
  if (mixed) {
    questionList = data.question_list
    storyList = data.story_list
  } else {
    questionList = data
  }
  questionList.forEach(item => {
    tpl += `
      <li class="recommend-content">
          <div class="tag">
            ${secondTags(item['second_tags'])}
          </div>

          <div class="author new-author">
            <div class="author-title">
              <a target="_blank" href="${api.host}/qa/${item['id']}">
                <p class="question-title">
                  ${item['major_title'] ? item['major_title'] : item['title']}
                  ${
                    item['show_start']
                      ? '<img class="start" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAz5JREFUWAntVk9IFFEY/74ZW9GCokt0kQQXqehgt/7QISkIwk5BoasS9OcSEe26Bh32UOGOG1YEgYWomx0Mog5FdDCwDkG3SCIMKvTiKSktbJv5+t6sM+zMvpl94ixdfDA7731/ft/vfe973yzA2vhPGaBU1z7xBIWvCVJELzd7ljGPybBRJoxaRj2J7WBZUzaupu1EI//RH0PzC6qytijFuGLTCMV5WZiqZ4R6u7eBWfgEBDE7OsIf0Nc1Y9/w11I2VSNCVxKNsGRdYgKnOGBdaVCe/+bcDEGtdgOv5r8IXeREqLezBf5aXJh0nPF1ESRkmEzhEdRohnKN0Pi4Tql2sbvwYVITk4izUSUSAodt2JZ9lDNCqY6TQHQHtmgNmMovhrNh+N7EQQ6QZp/DUlvEl6BjFvvyE0Kv3kcIROVvhjnrNL9vCuewsRxggtKd+8E0J9nW2TSBrh/A7OibUn+lo6GejkO8xxbbEfEiZTLKG7ADIj51g/LcT0LolIhw5addIKIGWJg+4a5VJkhZ16x07goViHBt7OZzbi3xEUl22rVHHLRAY+wtIL4Wjz2XGCpkhMqDEuzisz8iwQsRaQbvmx/5cApIqqXL7TugAO9ZWX4VxQ6b6lvx7GBB6uwTEpEdCxHJp7KXUiJFApgEpHa3NUu9cZb1A6DF7qEx9FNmoirzELH/L5DJhUlHGcCjCwfEefa5C7G6W3j9/ly4rVyLdspSXW0AdlveKzdTleIS0x/h9pTD/uFpVS9hh3wrkryba6FHsBLEou03Lqs2zI2K+lIaGvY/yAHWNjKnfn5+KHkFGuEHvqJdEF8fXwkJAeepA0qf2Qj06xxYcIGztDUwXrlikr8bBvTlnwfdinIXr8RDxFHR7fO1MPM9weskN7NmR+57E+/+CR+uEdSkfPahSykRx4My3ZtgoTDD6w2OzH0jjvGxdrjrVU5COytmhudBw0FpDAruklL7CsJQIkVfGuBS8nZPxBcrLcYKPCp/ffn8ZxnkoQcIo82GwFbICFvpOl9t7jT2wHdojL4qzqP7VSKC2ZEpvujP7LAaBX5BV0NLiUgxAPcJwM9QH3+8moCR+FKyc08kQGsgChn4Bwfc7n1o08NEAAAAAElFTkSuQmCC" alt="">'
                      : ''
                  }
                  ${questionReward(item, sshzv)}
                </p>
              </a>
            </div>
          </div>

          <div class="ask">
            <a target="_blank" href="${api.host + '/qa/' + item['id']}">
              <div class="ask-detail hide-content">
                ${filterBr(item['content'])}
              </div>
            </a>
            <div class="switch" data-tab="ques">...全文</div>
            <div class="arrow">收起</div>
          </div>

          <div class="ques-btn">
            <div class="ques-btn-answer">
              <a target="_blank" href="${api.host}/qa/${item['id']}">
                <span>写个回答</span>
              </a>
            </div>
            <div class="ques-btn-feel" data-question_id="${
              item['id']
            }" data-tab="ques">
              <p class="${
                +item['is_same_feeling'] ? 'has-feel' : ''
              }">有同感&nbsp;<span class="number">${
      item['same_feeling_num']
    }</span></p>
            </div>
            <div class="ques-btn-invite" data-question_id="${item['id']}">
              <span>还能邀答（<span class="time">${
                item['int_invite_number']
              }</span>次）</span>
            </div>
          </div>
      </li>
    `
  })
  storyList.forEach(item => {
    tpl += `<li class="topicItem">
      <a href="${api.host}/qa/real_time_story_detail/${item.story_id}">
        <img src="${item.avatar}" alt="" class="avatar">
        <div class="wrap">
          <div class="other">
            <span class="tag">#${item.topic_name}</span>
            <span class="join">${item.join_num}人参加</span>
          </div>
          <div class="content">${item.content}</div>
          <div class="showAll">看全文</div>
        </div>
      </a>
    </li>`
  })
  return tpl
}



// WEBPACK FOOTER //
// ./src/pages/ask/askBranch/render/questionList.js